import { all, takeLatest, put, call, select } from 'redux-saga/effects';

import {
  apiFetchCancelSubscriptionMethod,
  apiPostCancelSubscription,
} from '@dragonfruit/services/apis';
import * as actions from '@dragonfruit/redux/cancelSubscription';
import { actions as errorActions } from '@dragonfruit/redux/error';

export function* fetchCancelSubscriptionMethod() {
  try {
    const id = yield select(state => state.cancelSubscription.id);
    const { cancelMethod, questionnaire } = yield call(
      apiFetchCancelSubscriptionMethod,
      id
    );

    yield put(
      actions.fetchCancelSubscriptionMethodSuccess({
        cancelMethod,
        questionnaire,
      })
    );
  } catch (err) {
    yield put(actions.fetchCancelSubscriptionMethodFailure(err.errorMessage));
    yield put(errorActions.sendError(err));
  }
}

export function* postCancelSubscription(action) {
  try {
    const { postCancelSubscriptionData } = action.payload;
    const id = yield select(state => state.cancelSubscription.id);
    yield call(apiPostCancelSubscription, id, postCancelSubscriptionData);

    yield put(actions.postCancelSubscriptionSuccess());
  } catch (err) {
    yield put(actions.postCancelSubscriptionFailure(err.errorMessage));
    yield put(errorActions.sendError(err));
  }
}

export default function*() {
  yield all([
    takeLatest(
      actions.type.FETCH_CANCEL_SUBSCRIPTION_METHOD,
      fetchCancelSubscriptionMethod
    ),
    takeLatest(actions.type.POST_CANCEL_SUBSCRIPTION, postCancelSubscription),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/cancelSubscription.js